import { Link } from "react-router-dom";
import type { BlogCta } from "@/pages/blog/blogData";

export default function ArticleCtaBlock({ cta }: { cta: BlogCta }) {
  const isExternal = cta.to.startsWith("http");

  return (
    <div className="rounded-2xl border border-primary-200 bg-primary-50 p-6 md:p-8">
      <div className="flex flex-col items-start gap-5 md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-background-50">
            <i className="ri-sparkling-2-line" aria-hidden="true"></i>
            NXHOST
          </span>
          <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 md:text-xl">
            {cta.title}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cta.text}</p>
        </div>

        {isExternal ? (
          <a
            href={cta.to}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            {cta.label}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        ) : (
          <Link
            to={cta.to}
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            {cta.label}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        )}
      </div>
    </div>
  );
}